import React, { useState, useEffect } from 'react';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CmtCard from '@coremat/CmtCard';
import TestsRequests from 'services/tests';
import Rate from './Rate';

const useStyles = makeStyles(_ => ({
  cardContainer: {
    marginTop: 10,
  },
  assessmentInfoConatiner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  subtitle: {
    marginTop: 20,
    marginLeft: 5,
  },
  titleIcon: {
    marginRight: 8,
  },
}));

const CommentElement = ({ data }) => {
  const classes = useStyles();
  const [owner, setOwner] = useState(null);

  useEffect(() => {
    getCommentOwnerInfo();
  }, [data]);

  async function getCommentOwnerInfo() {
    try {
      const ownerInfo = await TestsRequests.getCommentOwner(data.owner);
      setOwner(ownerInfo);
    } catch (error) {
      console.log('Error loading userInfo:', error);
    }
  }

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        <CmtCard>
          <CmtCardContent sx={{ pb: 0 }}>
            <Box className={classes.assessmentInfoConatiner}>
              <Box width={'100%'}>
                <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                  <Typography variant="h3" color="textSecondary" component="h3">
                    {owner ? `${owner.fullName} (${owner.relation}) : ` : ''}
                  </Typography>
                </Box>
                <Typography color="textSecondary" className={classes.subtitle}>
                  {data.comment}
                </Typography>
                <Typography color="textSecondary" className={classes.subtitle}>
                  {owner ? `شماره تماس : ${owner.phone} ` : null}
                </Typography>
              </Box>
            </Box>
            <br />
            <Box width={'100%'} display={'flex'} justifyContent={'center'}>
              <Rate rate={data.score} />
            </Box>
          </CmtCardContent>
        </CmtCard>
      </div>
    </React.Fragment>
  );
};

export default CommentElement;
